import { i18next } from '@frontend/i18n';

export const validateExtension = (value: string, extensionsInUse: Set<number> = new Set()) => {
  if (!value.trim()) return i18next.t('Extension is required', { ns: 'phone' });
  if (!/^\d+$/.test(value)) return i18next.t('Extension must contain only digits', { ns: 'phone' });

  // Block special characters: | : @ ^ < > " =
  const invalidPattern = /[|:^@<>"=]/;
  if (invalidPattern.test(value)) {
    return i18next.t('Prohibited: | : @ ^ < > " =', { ns: 'phone' });
  }

  // May not start with 0
  if (value.startsWith('0')) return i18next.t('Extensions cannot start with a 0', { ns: 'phone' });

  const num = Number(value);

  // 711 is reserved for TDD and relay services for the deaf and hard of hearing
  if (value === '711')
    return i18next.t('711 is reserved for TDD and relay services for the deaf and hard of hearing', { ns: 'phone' });

  // 211, 311, 411, 511, 611, 711, 811, and 911 are not permitted for use
  if (/^[2-9]11$/.test(value))
    return i18next.t('211, 311, 411, 511, 611, 711, 811, and 911 are not permitted for use', { ns: 'phone' });

  // Extensions 6000-6999 are reserved for Weave use
  if (num >= 6000 && num <= 6999) return i18next.t('Extensions 6000-6999 are reserved for Weave use', { ns: 'phone' });

  // Extensions 60000-69999 are reserved for Weave use
  if (num >= 60000 && num <= 69999)
    return i18next.t('Extensions 60000-69999 are reserved for Weave use', { ns: 'phone' });

  // Extensions 600000-699999 are reserved for Weave use
  if (num >= 600000 && num <= 699999)
    return i18next.t('Extensions 600000-699999 are reserved for Weave use', { ns: 'phone' });

  // Four digit extensions starting with 7 are reserved for Weave Call Route Extensions (7000 - 7999)
  if (value.length === 4 && value.startsWith('7'))
    return i18next.t(
      'Four digit extensions starting with 7 are reserved for Weave Call Route Extensions (7000 - 7999)',
      { ns: 'phone' }
    );

  // 4+ digit extensions starting with 8 are reserved for Weave use (3-digit extensions starting with 8 are allowed)
  if ((num >= 8000 && num < 8999) || (num >= 80000 && num < 89999) || (num >= 800000 && num < 899999))
    return i18next.t('8 prefix with 4 or more digits is reserved for Weave use', { ns: 'phone' });

  // Extensions cannot start with a 9
  if (value.startsWith('9')) return i18next.t('Extensions cannot start with a 9', { ns: 'phone' });

  // Enforce 3-6 digit limit
  if (value.length < 3 || value.length > 6)
    return i18next.t('Extension must be between 3 and 6 digits', { ns: 'phone' });

  // Check if extension is already in use
  if (extensionsInUse.has(Number(value))) return i18next.t('This extension is already in use', { ns: 'phone' });

  return '';
};

// TODO: move this to a shared validation file
export const validateDeviceName = (value: string) => {
  if (!value.trim()) return i18next.t('Device name is required', { ns: 'phone' });

  if (value.length > 26) {
    return i18next.t('{{count}}/26 characters. Shorten label to 26 characters.', {
      count: value.length,
      ns: 'phone',
    });
  }

  const invalidPattern = /[|:^@<>"=]/;
  if (invalidPattern.test(value)) {
    return i18next.t('Prohibited: | : @ ^ < > " =', { ns: 'phone' });
  }

  return '';
};
